import type {PublicBallot} from '../../shared/ballotTypes';

export type VoterScreen =
    | 'loading'
    | 'name'
    | 'waiting'
    | 'ballot'
    | 'confirm'
    | 'thanks'
    | 'closed';

export const voterScreen = (
    ballot: PublicBallot | undefined,
    local: {confirming: boolean},
): VoterScreen => {
    if (!ballot) return 'loading';
    if (ballot.me?.voted) return 'thanks';
    if (ballot.status === 'closed' || ballot.status === 'revealed') return 'closed';
    if (!ballot.me) return 'name';
    if (ballot.status === 'draft') return 'waiting';
    return local.confirming ? 'confirm' : 'ballot';
};
